"use client";

import { GoogleTagManager } from "@shared/lib/scripts/gtm";
import { LANDING_LOCALE_STORAGE_KEY, LANDING_URL_STORAGE_KEY } from "@shared/utils";
import { useEffect } from "react";

export function ClientInit({ gtmId, locale }: { gtmId: string; locale: string }) {
  useEffect(() => {
    GoogleTagManager.init({ id: gtmId });
    localStorage.setItem(LANDING_URL_STORAGE_KEY, window.location.href);
  }, [gtmId]);

  useEffect(() => {
    const map: Record<string, string> = { "id-ID": "id", en: "en" };
    localStorage.setItem(LANDING_LOCALE_STORAGE_KEY, map[locale] ?? "en");
  }, [locale]);

  return null;
}
